import React, { useState } from "react";
import { Check, Loader2, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/apiClient";

export function ContactForm() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading"); setError("");
    try {
      await api.post("/contact", form);
      setState("done");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
      setState("idle");
    }
  };

  if (state === "done") {
    return (
      <div data-testid="contact-success" className="rounded-3xl glass p-10 text-center">
        <div className="inline-flex h-14 w-14 rounded-full bg-cyan/15 items-center justify-center mb-4">
          <Check className="text-cyan" size={28} />
        </div>
        <h3 className="font-display text-2xl text-white">Message sent.</h3>
        <p className="text-ice/70 mt-2">Thanks for reaching out — we'll be in touch soon.</p>
      </div>
    );
  }

  return (
    <form data-testid="contact-form" onSubmit={submit} className="rounded-3xl glass p-8 sm:p-10 space-y-5">
      <div>
        <label className="label block mb-2">Name</label>
        <input data-testid="contact-name" required value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none"
          placeholder="Your name" />
      </div>
      <div>
        <label className="label block mb-2">Email</label>
        <input data-testid="contact-email" required type="email" value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none"
          placeholder="your@email.com" />
      </div>
      <div>
        <label className="label block mb-2">Message</label>
        <textarea data-testid="contact-message" required rows={5} value={form.message}
          onChange={(e) => setForm({ ...form, message: e.target.value })}
          className="w-full rounded-xl bg-ink-800 border border-white/12 px-5 py-3.5 text-ice placeholder:text-mist focus:border-cyan/60 outline-none resize-none"
          placeholder="Tell us what's on your mind…" />
      </div>
      {error && <p className="text-red-300 text-sm" data-testid="contact-error">{error}</p>}
      <button data-testid="contact-submit" type="submit" disabled={state === "loading"} className="book-cta w-full justify-center">
        {state === "loading" ? <Loader2 className="animate-spin" size={16} /> : <>Send message <Send size={15} /></>}
      </button>
    </form>
  );
}

export default ContactForm;
